module.exports = __webpack_public_path__ + "img/logo.753b76a7.png";